export const SPONSORS = [
  {
    id: "superbet",
    name: "Superbet",
    logo: "https://customer-assets.emergentagent.com/job_1deead7c-0045-44e4-9e1c-6670283476c8/artifacts/pxsr24vk_superlogo.jpg",
    affiliateUrl: "https://tracker.superortaklik.com/link?btag=74933949_446475",
    tier: "main",
    description: "Spor bahisleri ve casino d\u00FCnyasında lider platform.",
    badge: "Pop\u00FCler"
  },
  {
    id: "maxwin",
    name: "Maxwin",
    logo: "https://customer-assets.emergentagent.com/job_gaming-tracker-5/artifacts/gj7kr4rl_165526-Photoroom.png",
    affiliateUrl: "https://track.maxortaklik.com/processing/click?btag=3686_4278",
    tier: "main",
    description: "Y\u00FCksek oranlar ve h\u0131zl\u0131 \u00F6deme garantisi.",
    badge: "G\u00FCvenilir"
  },
  {
    id: "ramadabet",
    name: "Ramadabet",
    logo: "https://customer-assets.emergentagent.com/job_gaming-tracker-5/artifacts/sb7ur77x_143256.png",
    affiliateUrl: "https://ramapartner.com/processing/click?btag=8311_9007",
    tier: "main",
    description: "Premium bahis deneyimi sunan g\u00FCvenilir platform.",
    badge: "Premium"
  },
  {
    id: "betasus",
    name: "Betasus",
    logo: "https://customer-assets.emergentagent.com/job_1deead7c-0045-44e4-9e1c-6670283476c8/artifacts/scwvxlh1_asuslogo.png",
    affiliateUrl: "https://asuspartner.com/links/?btag=2598615",
    tier: "main",
    description: "Geni\u015F oyun se\u00E7enekleri ile \u00F6ne \u00E7\u0131kan platform.",
    badge: "Yeni"
  },
  {
    id: "royalbet",
    name: "Royalbet",
    logo: "https://customer-assets.emergentagent.com/job_gaming-tracker-5/artifacts/pa0g3yla_royneww.png",
    affiliateUrl: "https://royalortaklik.com/links/?btag=2257233",
    tier: "vip",
    description: "Kraliyetin bahis deneyimi.",
    badge: "VIP"
  },
  {
    id: "pashagaming",
    name: "Pashagaming",
    logo: "https://customer-assets.emergentagent.com/job_gaming-tracker-5/artifacts/rmunn17m_pashalogo.png",
    affiliateUrl: "https://eticaretbayimiz.com/links/?btag=2321890",
    tier: "vip",
    description: "12 y\u0131ll\u0131k tecr\u00FCbe ile g\u00FCvenilir bahis.",
    badge: "12 Y\u0131l"
  },
  {
    id: "venombet",
    name: "Venombet",
    logo: "https://customer-assets.emergentagent.com/job_1deead7c-0045-44e4-9e1c-6670283476c8/artifacts/j42b25de_venomlogo.jpeg",
    affiliateUrl: "https://tracking.ticaretbayi.com/processing/click?btag=2509_2457",
    tier: "vip",
    description: "Best Sports Betting & Casino deneyimi.",
    badge: "Pop\u00FCler"
  },
  {
    id: "spinco",
    name: "Spinco",
    logo: "https://customer-assets.emergentagent.com/job_gaming-tracker-5/artifacts/69ezqm8s_logosss-Photoroom.png",
    affiliateUrl: "https://tracker.satispanel2.com/link?btag=80817845_484947",
    tier: "vip",
    description: "\u015Eans oyunlar\u0131nda yeni nesil deneyim.",
    badge: "Yeni"
  }
];

export const BONUS_SPONSORS = [
  {
    id: "stake",
    name: "Stake",
    logo: "https://customer-assets.emergentagent.com/job_gaming-tracker-5/artifacts/lq2up2j6_still-2778c286e035a4d088fe2e7af4a18fef-Photoroom.png",
    affiliateUrl: "https://sta.ke/45BdREr",
    tier: "bonus",
    description: "D\u00FCnyan\u0131n en pop\u00FCler kripto bahis platformu.",
    badge: "Kripto"
  },
  {
    id: "megapari",
    name: "MegaPari",
    logo: "https://customer-assets.emergentagent.com/job_gaming-tracker-5/artifacts/y27ne5mn_images%20%285%29-Photoroom.png",
    affiliateUrl: "https://3662299.nowfit.top",
    tier: "bonus",
    description: "Geni\u015F bahis se\u00E7enekleri ve y\u00FCksek oranlar.",
    badge: "Mega"
  },
  {
    id: "gamdom",
    name: "Gamdom",
    logo: "https://customer-assets.emergentagent.com/job_gaming-tracker-5/artifacts/5rfw76jj_Gamdom-Casino-Photoroom.png",
    affiliateUrl: "https://cutt.ly/gamcasino",
    tier: "bonus",
    description: "Casino ve spor bahisleri i\u00E7in g\u00FCvenilir adres.",
    badge: "Casino"
  },
  {
    id: "tempobet",
    name: "Tempobet",
    logo: "https://customer-assets.emergentagent.com/job_gaming-tracker-5/artifacts/mc2mxueb_images%20%283%29-Photoroom.png",
    affiliateUrl: "https://bit.ly/Tempobet-yeni-adres",
    tier: "bonus",
    description: "Y\u00FCksek oranlar ve h\u0131zl\u0131 \u00F6deme ile \u00F6ne \u00E7\u0131kan platform.",
    badge: "H\u0131zl\u0131"
  },
  {
    id: "mobilbahis",
    name: "Mobilbahis",
    logo: "https://customer-assets.emergentagent.com/job_gaming-tracker-5/artifacts/vnk2bzs3_HBKWifbXwAAmRKF-Photoroom.png",
    affiliateUrl: "https://tinyurl.com/2kh8e3ab",
    tier: "bonus",
    description: "Mobil uyumlu bahis deneyimi sunan platform.",
    badge: "Mobil"
  },
  {
    id: "bets10",
    name: "Bets10",
    logo: "https://customer-assets.emergentagent.com/job_gaming-tracker-5/artifacts/da6ez22s_DgyokKBXUAI5vqZ-Photoroom.png",
    affiliateUrl: "https://tinyurl.com/5e6srnmz",
    tier: "bonus",
    description: "Geni\u015F spor bahisleri ve casino se\u00E7enekleri.",
    badge: "Spor"
  },
  {
    id: "1xbet",
    name: "1xBet",
    logo: "https://customer-assets.emergentagent.com/job_gaming-tracker-5/artifacts/pa2zftiq_images%20%286%29-Photoroom.png",
    affiliateUrl: "http://1x-sports.com/1XTAKIM",
    tier: "bonus",
    description: "D\u00FCnya \u00E7ap\u0131nda spor bahisleri ve casino platformu.",
    badge: "Global"
  },
  {
    id: "1win",
    name: "1Win",
    logo: "https://customer-assets.emergentagent.com/job_gaming-tracker-5/artifacts/osorv180_images%20%284%29-Photoroom%20%281%29.png",
    affiliateUrl: "https://1wglobal.mssg.me/",
    tier: "bonus",
    description: "H\u0131zl\u0131 ve g\u00FCvenilir bahis deneyimi.",
    badge: "Yeni"
  }
];

export const CONTACT_INFO = {
  telegram: { url: "https://t.me/marsh4al", handle: "@marsh4al", label: "Telegram" },
  teams: { url: "https://teams.live.com/l/invite/FEA9wKX2TrGlleluQE?v=g1", label: "Microsoft Teams" },
  email: { address: "support@betmax.store", label: "E-posta" }
};

export const getMainSponsors = () => SPONSORS.filter(s => s.tier === "main");
export const getVipSponsors = () => SPONSORS.filter(s => s.tier === "vip");
